import { Blocs } from '@business/blocs';
import { FileResponse, FolderId, FolderResponse } from '@business/entities/file';
import { OrgId } from '@business/entities/organization';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

export class OrgFormsBloc extends BaseBloc {
  private readonly fileBloc = resolve(Blocs.fileForm);

  constructor(private readonly orgId: OrgId) {
    super();
  }

  loading = new LoadingState();

  readonly items$ = this.fileBloc.items$;
  readonly breadcrumb$ = this.fileBloc.breadcrumb$;

  getItems = this.fileBloc.getItems;
  createFolder = this.fileBloc.createFolder;
  renameFolder = this.fileBloc.renameFolder;
  deleteFolder = this.fileBloc.deleteFolder;
  renameFile = this.fileBloc.renameFile;
  deleteFile = this.fileBloc.deleteFile;
  createDocument = this.fileBloc.createDocument;
  downloadFolder = this.fileBloc.downloadFolder;
  changeFolderVisibility = this.fileBloc.changeFolderVisibility;
  changeFileVisibility = this.fileBloc.changeFileVisibility;
  itemShareUsers = this.fileBloc.itemShareUsers;
  changeFolderStatus = this.fileBloc.changeFolderStatus;

  searchItems$ = new BehaviorSubject<(FolderResponse | FileResponse)[]>([]);

  search = (search: string, parentId?: FolderId) => {
    return this.fileBloc.search(this.orgId, search, parentId, 'forms').pipe(tap(data => this.searchItems$.next(data.items)));
  };
}
